export default class Banner {
  constructor() {
    this.bigDesktop = 1360;
    this.marginBottomBanner = 80;
  }

  setPosition() {
    const newViewContentHeight = this.newViewContent.offsetHeight;
    const bannerHeight = this.banners[0].offsetHeight;
    const bannerOffsetTop = this.banners[0].offsetTop;

    if (
      bannerOffsetTop + bannerHeight + this.marginBottomBanner >
      newViewContentHeight
    ) {
      this.banners[0].style.top = '50%';
      this.banners[0].style.transform = 'translateY(-50%)';
    }
  }

  init() {
    if (document.querySelector('.article-page__banner') !== null && window.innerWidth >= this.bigDesktop) {
      this.newViewContent = document.querySelector('.news-view__content-wrapper');
      this.banners = this.newViewContent.querySelectorAll(
        '.article-page__banner'
      );
      this.setPosition();
    }
  }
}
